import {Outlet} from "react-router-dom";
import Header from "../components/common/Header";
import Sidebar from "../components/common/Sidebar";
import Footer from "../components/common/Footer";
import {selectActiveWebProfileId} from "../store/selectors";
import {useSelector} from "react-redux";
import {useNotificationsSocket} from "../components/notification/useNotificationsSocket";
import {NOTIFICATION_WS_URL} from "../constants/vars";

export default function AdminRoot() {
    const profileId = useSelector(selectActiveWebProfileId);

    useNotificationsSocket({
        profileId,
        wsBaseUrl: NOTIFICATION_WS_URL,
    });

    return (
        <div className="wrapper" >
            <Header/>
            <Sidebar/>
            <main>
                <Outlet />
            </main>
            <Footer/>
        </div>
    );
}